var ventura = {};
var isTemplate = WP_PARAMS.is_page_template;

import './parts/menu';
import './parts/button';
import './parts/checkout/form-checkout';
import './parts/checkout/checkout';
import './parts/product-slider';
import './parts/search-filter';

import './parts/form/form-piva-subscription';
import './parts/zoho/zc-consent';
//import './parts/christmas-box';

(function($) {
    ventura.init = () => {
        ventura.test();
        //ventura.onResize();
        //ventura.vhVariable();
        //avvio dei satelliti

        $(document).trigger('venturaReady');
    }

    $(document).ready(function() {
        ventura.init();
    });

    $(window).on('resize', function(){
    });

    ventura.test = () => {
        console.log('start ' + isTemplate);

    }

    ventura.onResize = () => {
        const windowWidth = window.innerWidth;

        if (windowWidth > 768) {
            $(".prd_image").prependTo(".single-prodotto");
        } else {
            $(".prd_image").appendTo(".img-mobile-placeholder");
        }

        if (windowWidth > 991) {
            $("body").removeClass("menu_mobile_aperto");
        }

        if (typeof ventura.vhVariable === "function") {
            ventura.vhVariable();
        }
    };

    ventura.vhVariable = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

})(jQuery);

// Espone ventura globalmente per i satelliti
window.ventura = ventura;
window.isTemplate = isTemplate;
